export enum ITRequestItem {
  NEW_SIM_CARD = 'New SIM Card',
  EMAIL = 'Email',
  BUILD_SMART_ACCESS = 'Build Smart Access',
  ACCESSORIES = 'Accessories',
  INTERNATIONAL_CALLS = 'International Calls',
  LOST_SIM_CARD = 'Lost SIM Card',
  ASSET_STATUS_CHANGE = 'Asset Status Change',
  SIM_ADDON_REQUEST = 'SIM Addon Request',
}
